'use client'

/**
 * Repli du détail complet d'un projet (mise en page « Vitrine »).
 *
 * Sur mobile, le détail se replie après la photo et la part de l'entreprise :
 * « Voir le détail complet ». Sur grand écran (≥ lg), il est toujours ouvert
 * et le bouton disparaît.
 *
 * Le détail est TOUJOURS dans le HTML rendu par le serveur (lu par les
 * moteurs et les lecteurs d'écran une fois ouvert) : replié, il est seulement
 * masqué par CSS sous lg. Le bouton porte `aria-expanded` et `aria-controls`,
 * se manœuvre au clavier (Entrée, Espace) comme tout bouton natif.
 */
import { useId, useState } from 'react'

export default function DetailRepliable({ children, titre }: { children: React.ReactNode; titre: string }) {
  const [ouvert, setOuvert] = useState(false)
  const id = useId()
  return (
    <>
      <button
        type="button"
        aria-expanded={ouvert}
        aria-controls={id}
        onClick={() => setOuvert((v) => !v)}
        className="flex min-h-[48px] w-full items-center justify-between gap-3 rounded-xl border border-forest/20 bg-white px-4 text-left font-heading text-[15px] font-semibold text-forest transition-colors hover:bg-sage/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest lg:hidden"
      >
        <span>
          {ouvert ? 'Replier le détail' : 'Voir le détail complet'}
          <span className="sr-only"> du projet {titre}</span>
        </span>
        <svg aria-hidden viewBox="0 0 20 20" className={`h-5 w-5 flex-shrink-0 transition-transform ${ouvert ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 8l5 5 5-5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div id={id} className={ouvert ? 'mt-8 block' : 'hidden lg:block'}>
        {children}
      </div>
    </>
  )
}
